import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useSubscriptionCheck from '../../common/SubscriptionCheck';

function SupplierListPageActions() {
  const navigate = useNavigate();
  const { checkSubscription, SubscriptionModal } = useSubscriptionCheck();

  const handleCreateAction = () => {
    if (!checkSubscription()) {
      return;
    }
    navigate('/suppliers/create');
  };

  return (
    <>
      <Button
        id="create-supplier"
        key="add-new-Supplier"
        variant="contained"
        color="primary"
        onClick={handleCreateAction}
      >
        + Create New Supplier
      </Button>
      <SubscriptionModal />
    </>
  );
}

export default SupplierListPageActions;
